/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'paper': {
    width: 22,
    height: 26,
    viewBox: '0 0 22 26',
    data: '<path pid="0" d="M.9 3.667A2.759 2.759 0 013.65.9h9.594a.727.727 0 01.5.195l7.129 6.767a.773.773 0 01.227.538v13.933c0 .735-.29 1.438-.806 1.957a2.742 2.742 0 01-1.945.81H3.651c-.73 0-1.43-.291-1.945-.81A2.773 2.773 0 01.9 22.333V3.667zm13.107 3.405a.533.533 0 00.564.562h3.859l-4.423-4.201v3.64zM12.48 2.434h-8.83c-.677 0-1.225.552-1.225 1.233v18.666c0 .681.548 1.233 1.225 1.233h14.698c.325 0 .636-.13.866-.36.23-.232.359-.546.359-.873V9.167h-5.002a2.052 2.052 0 01-1.49-.606 2.073 2.073 0 01-.6-1.495V2.434zM6.267 12.1c0-.417.157-.767.4-.767h3.662c.242 0 .4.35.4.767 0 .417-.158.767-.4.767H6.667c-.243 0-.4-.35-.4-.767zm.525 8.767c-.301 0-.525-.35-.525-.767 0-.416.224-.766.525-.766h8.383c.302 0 .525.35.525.766 0 .417-.223.767-.525.767H6.792zm0-4.083c-.301 0-.525-.35-.525-.768 0-.416.224-.766.525-.766h8.383c.302 0 .525.35.525.766 0 .417-.223.768-.525.768H6.792z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
